// extracted by mini-css-extract-plugin
export default {"wrapper":"wo1hn7","card":"fh8f1b","lottie":"JkvL1N","button":"MupQ4n","desktop":"CZ33Vi"};